import { customInstance } from "../../api-client";
import { getOneAppRequest } from "../school-reports/oneAppRequest";

import type {
  OnboardingEligibility,
  OnboardingEligibilityHeaders,
  OnboardingEligibilityResponse,
} from "./types";

const PATH = "/students/onboarding-eligibility";

function buildRequestOptions(headers: OnboardingEligibilityHeaders) {
  return {
    ...getOneAppRequest(),
    headers: {
      userId: headers.userId,
      platform: headers.platform,
    },
  };
}

export async function getOnboardingEligibility(
  headers: OnboardingEligibilityHeaders,
  signal?: AbortSignal,
): Promise<OnboardingEligibilityResponse> {
  return customInstance<OnboardingEligibilityResponse>(
    { url: PATH, method: "GET", signal },
    buildRequestOptions(headers),
  );
}

export async function updateOnboardingEligibility(
  body: OnboardingEligibility,
  headers: OnboardingEligibilityHeaders,
): Promise<OnboardingEligibilityResponse> {
  return customInstance<OnboardingEligibilityResponse>(
    {
      url: PATH,
      method: "PUT",
      data: body,
    },
    {
      ...getOneAppRequest(),
      headers: {
        "Content-Type": "application/json",
        userId: headers.userId,
        platform: headers.platform,
      },
    },
  );
}

export const getOnboardingEligibilityQueryKey = (userId?: string) =>
  [PATH, userId ?? ""] as const;
